/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetStakingRewardsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetStakingRewardsQuery = {
	__typename?: "Query";
	balances: Array<{
		__typename?: "StakingBalance";
		asset: { __typename?: "StakeableAsset"; assetId: string };
		stakedAmount: { __typename?: "CurrencyAmount"; value: string };
	}>;
	assetConfig: {
		__typename?: "AssetConfigResponse";
		assets?: Array<{
			__typename?: "StakeableAsset";
			assetId: string;
			rewardIntervalInDays: number;
			nextReward: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
		}> | null;
	};
};

export const GetStakingRewardsDocument = gql`
	query getStakingRewards {
		balances {
			asset {
				assetId
			}
			stakedAmount {
				value
			}
		}
		assetConfig {
			assets {
				assetId
				rewardIntervalInDays
				nextReward {
					iso8601
					unixTimestamp
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetStakingRewardsGQLService extends Apollo.Query<GetStakingRewardsQuery, GetStakingRewardsQueryVariables> {
	document = GetStakingRewardsDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
